import { arbitrum } from 'wagmi/chains';

export const USDC_CONTRACT = {
  [arbitrum.id]: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
};
export const HYPER_DEPOSIT_CONTRACT =
  '0x2df1c51e09aecf9cacb7bc98cb1742757f163df7';
